export const BP = {
    blogPage: document.querySelector('.js-blog-page'),

    _state: {
        page: 0,
        pageSize: 12,
        display: 'pagination',
        total: 0
    },

    _paramAliases: {
        tags: ["tag"],
        types: ["type"],
        years: ["year"],
        rubriques: ["rubrique"]
    },

    init: () => {
        if (!BP.blogPage) return;

        BP.initLayoutChange();
        BP.initMap();
        BP.initArticles();
    },

    initLayoutChange: () => {
        const btnGroupFilters = document.querySelector('.js-btn-group-filters');
        const newsContainer = document.querySelector('.js-news-cards-container');

        if (!btnGroupFilters || !newsContainer) return;

        const setDatasetFromButton = (btn) => {
            if (btn.classList.contains('list')) {
                newsContainer.dataset.blog = "list";
            } else if (btn.classList.contains('grid')) {
                newsContainer.dataset.blog = "grid";
            } else if (btn.classList.contains('tags')) {
                newsContainer.dataset.blog = "tags";
            } else if (btn.classList.contains('map')) {
                newsContainer.dataset.blog = "map";
            }
        };

        const activeBtn = btnGroupFilters.querySelector('.btn.active');
        if (activeBtn) setDatasetFromButton(activeBtn);

        btnGroupFilters.querySelectorAll('.btn').forEach(btn => {
            btn.addEventListener('click', () => {
                btnGroupFilters.querySelectorAll('.btn').forEach(b => b.classList.remove('active'));

                btn.classList.add('active');

                setDatasetFromButton(btn);
            });
        });
    },

    initMap: () => {
        //if (!mapContainer) return;

        const activateMapBtn = document.querySelector('.js-blog-page-activate-map');
        const gridArticleBtn = document.querySelector('.js-blog-page-grid');
        const listArticleBtn = document.querySelector('.js-blog-page-list');
        const tagBtn = document.querySelector('.js-blog-page-tags');
        const articlesContainer = document.querySelector('.js-blog-page-articles-block');
        const tagsContainer = document.querySelector('.js-blog-page-tags-block');
        const mapContainer = document.querySelector('.js-blog-page-map-block');

        // Small function to show only one container
        const containers = [mapContainer, tagsContainer, articlesContainer];
        const showOnly = (containerToShow) => {
            containers.forEach(c => c?.classList.add('d-none'));
            containerToShow?.classList.remove('d-none');
        };

        const selectDisplay = (mode) => {
            if (mode === 'map') showOnly(mapContainer);
            else if (mode === 'tags') showOnly(tagsContainer);
            else showOnly(articlesContainer);

            [gridArticleBtn, listArticleBtn, tagBtn, activateMapBtn].forEach(btn => { btn?.classList?.remove('active'); });

            //console.log(mode);
            if (activateMapBtn) {
                if (mode === 'map') {
                    activateMapBtn.setAttribute('disabled', '');
                    activateMapBtn.classList.add('active');
                }
                else activateMapBtn.removeAttribute('disabled');
            }

            if (tagBtn) {
                if (mode === 'tags') {
                    tagBtn.setAttribute('disabled', '');
                    tagBtn.classList.add('active');
                }
                else tagBtn.removeAttribute('disabled');
            }

            if (gridArticleBtn) {
                if (mode === 'grid') {
                    gridArticleBtn.setAttribute('disabled', '');
                    gridArticleBtn.classList.add('active');
                } else gridArticleBtn.removeAttribute('disabled');
            }

            if (listArticleBtn) {
                if (mode === 'list') {
                    listArticleBtn.setAttribute('disabled', '');
                    listArticleBtn.classList.add('active');
                } else listArticleBtn.removeAttribute('disabled');
            }
            localStorage.setItem('blogDisplay', mode);
        };

        activateMapBtn?.addEventListener('click', () => selectDisplay('map'));
        tagBtn?.addEventListener('click', () => selectDisplay('tags'));
        gridArticleBtn?.addEventListener('click', () => selectDisplay('grid'));
        listArticleBtn?.addEventListener('click', () => selectDisplay('list'));

        // Cache previous selected button
        const cached = (localStorage.getItem('blogDisplay') || 'grid').toLowerCase();
        selectDisplay(['map','tags','list'].includes(cached) ? cached : 'grid');
        
        // On load, if we got only one dispo, show it and disable the button
        const activeButtons = [activateMapBtn, tagBtn, gridArticleBtn, listArticleBtn].filter(Boolean);
        if (activeButtons.length === 1) {
            if (tagBtn) showOnly(tagsContainer);
            else if (activateMapBtn) showOnly(mapContainer);
            else if (listArticleBtn || gridArticleBtn) showOnly(articlesContainer);

            activeButtons[0].setAttribute('disabled', '');
        }
    },

    initArticles: () => {
        const filterBlocks = document.querySelectorAll(".js-blog-page-filter");
        const articlesBlock = document.querySelector(".js-news-cards-container");

        if (!articlesBlock) return;

        const skin = BP.blogPage.dataset.skins;
        const pageSize = parseInt(BP.blogPage.dataset.pageSize, 10);
        const display = (BP.blogPage.dataset.blogDisplay).toLowerCase();

        BP._state.pageSize = pageSize;
        BP._state.display = display;
        BP._state.page = BP._getPageFromURL();

        BP._applyURLToFilters(filterBlocks);

        // first load
        BP.fetchArticles({ skin, pageSize, page: BP._getPageFromURL(), q: BP._buildQFromFilters(filterBlocks) });

        // changes
        filterBlocks.forEach(block => {
            block.querySelectorAll(".js-blog-page-filter-option").forEach(input => {
                input.addEventListener("change", () => {
                    BP._syncURLWithFilters(filterBlocks, /*resetPage*/true);
                    BP.fetchArticles({ skin, pageSize, page: 0, q: BP._buildQFromFilters(filterBlocks) });
                });
            });
        });

        // navigation history (back/forward)
        window.addEventListener("popstate", () => {
            BP._applyURLToFilters(filterBlocks);
            BP.fetchArticles({ skin, pageSize, page: BP._getPageFromURL(), q: BP._buildQFromFilters(filterBlocks) });
        });

        // pagination
        document.addEventListener("click", (e) => {
            const a = e.target.closest("[data-action='bp-goto-page']");
            if (!a) return;

            const mode = (BP.blogPage.dataset.blogDisplay || '').toLowerCase();
            if (mode === 'infinitescroll') return;
            
            e.preventDefault();

            const page = parseInt(a.dataset.page, 10) || 0;
            BP._setURLPage(page);
            BP.fetchArticles({ skin, pageSize, page, q: BP._buildQFromFilters(filterBlocks) });
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        //load more (infinite scroll)
        const loadMoreBtn = document.querySelector(".js-load-more");
        const pagWrap = document.querySelector(".js-blog-page-infinite-scroll");
        if (display === "infinitescroll") {
            if (pagWrap) pagWrap.classList.remove("d-none");
            if (loadMoreBtn) {
                loadMoreBtn.classList.remove("d-none");
                loadMoreBtn.addEventListener("click", async () => {
                    // Double click issue
                    if (loadMoreBtn.disabled) return;
                    loadMoreBtn.disabled = true;


                    const next = (BP._state.page || 1) + 1;
                    BP._state.page = next;

                    await BP.fetchArticles({ skin, page: next, pageSize, q: BP._buildQFromFilters(filterBlocks), append: true });

                    loadMoreBtn.disabled = false;
                });
            }
        } else {
            if (loadMoreBtn) loadMoreBtn.classList.add("d-none");
        }
    },

    // ---- API ----
    fetchArticles: async ({ skin, page, pageSize, q, append = false }) => {
        //console.log("FETCH ARTICLE NOW");
        const url = new URL("/Umbraco/Api/ArticlesApi/GetBlogArticles", window.location.origin);
        url.searchParams.set("skin", skin || "all");
        url.searchParams.set("page", String(page > 0 ? page : 0));
        url.searchParams.set("pageSize", String(pageSize > 0 ? pageSize : 12));
        url.searchParams.set("sortOrder", String(BP.blogPage.dataset.sortOrder));
        url.searchParams.set("sourceFolders", String(BP.blogPage.dataset.sourceFolders));
        url.searchParams.set("showOnlyBasicData", true);

        // 'q' param
        // { years:["2023","2024"], types:["image"], tags:["Economie"], rubriques:["aroundus"] })
        if (q && Object.keys(q).length) {
            url.searchParams.set("q", JSON.stringify(q));
        }

        //console.log("URL", url.toString());
        try {
            const res = await fetch(url.toString(), {
                method: "GET",
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            
            const payload = await res.json();
            //console.log("PAYLOAD", payload);

            const data = payload?.data ?? payload;

            const total = data?.total || data?.Total || 0;
            BP._state.total = total;

            if (append) BP._appendArticles(data);
            else BP._renderArticles(data);

            if (BP._state.display === "infinitescroll") {
                BP._updateLoadMore({ total, page, pageSize });
            } else {
                BP._renderPagination(data, page, pageSize);
            }
        } catch (err) {
            console.error("fetchArticles error:", err);
            BP._renderError();
        }
    },

    // ---- Helpers filters <-> URL ----
    _buildQFromFilters: (filterBlocks) => {
        const q = {};
        filterBlocks.forEach(block => {
            const param = block.dataset.param; // ex: "years", "tags", "types", "rubriques"
            const values = Array.from(block.querySelectorAll(".js-blog-page-filter-option:checked")).map(i => i.value);
            if (values.length) q[param] = values;
        });
        return q;
    },

    _syncURLWithFilters: (filterBlocks, resetPage = false) => {
        const params = new URLSearchParams(window.location.search);

        // old - reset
        filterBlocks.forEach(block => {
            const param = block.dataset.param;
            params.delete(param);
            if (BP._paramAliases?.[param]) {
                BP._paramAliases[param].forEach(a => params.delete(a));
            }
        });
        
        // new
        filterBlocks.forEach(block => {
            const param = block.dataset.param;
            const checked = Array.from(block.querySelectorAll(".js-blog-page-filter-option:checked")).map(i => i.value);
            checked.forEach(v => params.append(param, v));
        });
        if (resetPage) params.set("page", "0");
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", newUrl);
    },

    _applyURLToFilters: (filterBlocks) => {
        const params = new URLSearchParams(window.location.search);

        const collectValues = (param) => {
            let vals = params.getAll(param);
            if (!vals.length && BP._paramAliases?.[param]?.length) {
                BP._paramAliases[param].forEach(a => {
                    vals = vals.concat(params.getAll(a));
                });
            }
            return vals;
        };

        filterBlocks.forEach(block => {
            const param = block.dataset.param;
            const values = collectValues(param).filter(Boolean);
            block.querySelectorAll(".js-blog-page-filter-option").forEach(input => {
                input.checked = values.includes(input.value);
            });
        });
    },

    _getPageFromURL: () => {
        const p = parseInt(new URLSearchParams(window.location.search).get("page") || "0", 10);
        return p >= 0 ? p : 0;
    },

    _setURLPage: (page) => {
        const params = new URLSearchParams(window.location.search);
        params.set("page", String(Math.max(0, page)));
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    },

    _renderArticles: (apiResponse) => {
        const container = document.querySelector(".js-news-cards-container .row");
        if (!container) return;

        const results = apiResponse?.results ?? apiResponse?.Results ?? [];
        container.innerHTML = "";
        //console.log("RES", results);
        if (!results.length) {
            container.innerHTML = `<div class="col-12 py-4 text-center text-muted">Aucun r&eacute;sultat.</div>`;
            return;
        }

        const cards = results.map((a, i) => BP._articleCard(a, i)).join("");
        container.innerHTML = cards;
    },

    _articleCard: (a, i) => {
       const safe = BP._normalizeArticle(a);
       //console.log(BP.blogPage.dataset.domain);
       return BP._cardDefault(safe, i);
    },

    _normalizeArticle: (a) => {
        //console.log(a.DatePublished);
        return {
            id: a.Id || a.Slug || "",
            slug: a.Slug,
            title: a.Title || "",
            img: a.Image,
            date: a.DatePublished || "",
            excerpt: a.Hat || "",
            tags: a.Tags || [],
            location: a.Localisation || null,
        };
    },
 
    _appendArticles: (apiResponse) => {
        const container = document.querySelector(".js-news-cards-container .row");
        if (!container) return;

        const results = apiResponse?.results ?? apiResponse?.Results ?? [];
        if (!results.length) return;

        const cards = results.map((a, i) => BP._articleCard(a, i)).join("");
        container.insertAdjacentHTML("beforeend", cards);
    },

    _cardDefault: (a, i) => {
        const withQuery = (url, q) => url + (url.includes('?') ? '&' : '?') + q;
        const srcSmall = withQuery(a.img, 'width=480&height=260&scale=both&crop=auto');
        const srcLarge = withQuery(a.img, 'width=600&height=325&scale=both&crop=auto');
        const srcImg = withQuery(a.img, 'width=600&height=325&crop=auto');

        return `
            <article class="mb-4">
                <div class="card d-block position-relative overflow-hidden text-white">
                    <div class="card-img-container position-relative">
                        <a href="fr/${a.slug}" target="_self">
                          <picture>
                            <!--[if IE 9]><video style="display:none;"><![endif]-->
                            <source srcset="${srcSmall}" media="(max-width: 480px)">
                            <source srcset="${srcLarge}">
                            <!--[if IE 9]></video><![endif]-->
                            <img 
                              class="card-img w-100 p-0 object-fit-cover"
                              src="${srcImg}" 
                              alt="${a.title}" 
                              loading="lazy">
                          </picture>

                          <div class="card-img-overlay d-flex flex-column justify-content-end p-3">
                              <div class="card-date">${BP._fmtDate(a.date)}</div>
                              <h5 class="card-title">${a.title}</h5>
                          </div>
                        </a>
                    </div>
                    <div class="card-footer">
                        ${a.excerpt}

                    </div>
                    <div class="card-link">
                        <a class="btn-next-card" href="fr/${a.slug}" target="_self" title="lire la suite"></a>
                    </div>
                </div>
            </article>`;
    },

    _fmtDate: (iso) => {
        try {
            return new Date(iso).toLocaleDateString('fr-CH', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        } catch { return iso; }
    },

    _hasMore: ({ total, page, pageSize }) => {
        const shown = ((page + 1) * pageSize);
        return shown < total;
    },

    _updateLoadMore: ({ total, page, pageSize }) => {
        const btn = document.querySelector(".js-load-more");
        if (!btn) return;

        const more = BP._hasMore({ total, page, pageSize });
        btn.disabled = !more;
        btn.classList.toggle("d-none", !more);
    },

    _renderPagination: (apiResponse, currentPage, pageSize) => {
        const wrap = document.querySelector(".js-blog-page-pagination");
        if (!wrap) return;

        if (BP._state.display === "infinitescroll") return;

        const total = apiResponse?.total || apiResponse?.Total || 0;
        const pages = Math.max(1, Math.ceil(total / pageSize));

        if (pages <= 1) { wrap.innerHTML = ""; return; }

        const cur = Number.isFinite(currentPage) && currentPage >= 0 ? currentPage : 0;
        const items = [];

        const mk = (p0, label = p0 + 1, active = false) =>
            `<li class="page-item ${active ? "active" : ""}">
               <a class="page-link text-decoration-none" href="#" data-action="bp-goto-page" data-page="${p0}">${label}</a>
             </li>`;

        // Prev
        items.push(`
            <li class="page-item ${cur <= 0 ? "disabled" : ""}">
              <a class="page-link text-decoration-none" href="#" data-action="bp-goto-page" data-page="${Math.max(0, cur - 1)}" aria-label="Précédent">&lt;</a>
            </li>`);

        // Pages
        for (let p0 = 0; p0 < pages; p0++) items.push(mk(p0, p0 + 1, p0 === cur));

        // Next
        items.push(`
            <li class="page-item ${cur >= pages - 1 ? "disabled" : ""}">
              <a class="page-link text-decoration-none" href="#" data-action="bp-goto-page" data-page="${Math.min(pages - 1, cur + 1)}" aria-label="Suivant">&gt;</a>
            </li>`);

        wrap.innerHTML = `<nav aria-label="Pagination"><ul class="pagination">${items.join("")}</ul></nav>`;
    },

    _renderError: () => {
        const container = document.querySelector(".js-news-cards-container .row");
        if (!container) return;
        container.innerHTML = `<div class="col-12 py-4 text-center text-danger">Une erreur est survenue lors du chargement des articles.</div>`;
    }
};